import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { sizeClassName, alignmentClassName } from '../../classNameStrategies';
export default function imageComponentWrapper(ExternalComponent) {
    var _React_Component, _ImageComponentWrapper;
    return withDimensions((_ImageComponentWrapper = class ImageComponentWrapper extends (_React_Component = React.Component) {
        render() {
            const { componentData: { config, data }, width, settings } = this.props;
            return /*#__PURE__*/ React.createElement(ExternalComponent, {
                config: config,
                data: data,
                width: width,
                settings: settings
            });
        }
        constructor(props){
            super(props);
            _define_property(this, "handleFilesAdded", ({ data, error })=>{
                const { componentData } = this.props;
                if (error) {
                    return;
                }
                const deviationData = data.length ? data[0] : data;
                this.props.store.set('componentData', _object_spread_props(_object_spread({}, componentData), {
                    data: deviationData
                }), this.props.block.getKey());
            });
            _define_property(this, "handleFilesSelected", (data)=>{
                const { componentData } = this.props;
                this.props.store.set('componentData', _object_spread_props(_object_spread({}, componentData), {
                    data
                }), this.props.block.getKey());
            });
            _define_property(this, "handleMetadataChange", (newMetadata)=>{
                const { componentData } = this.props;
                const metadata = _object_spread({}, componentData.metadata, newMetadata);
                this.props.store.set('componentData', _object_spread_props(_object_spread({}, componentData), {
                    metadata
                }), this.props.block.getKey());
            });
            const { block, store } = this.props;
            if (store) {
                const blockKey = block.getKey();
                store.setBlockHandler('handleFilesSelected', blockKey, this.handleFilesSelected.bind(this));
                store.setBlockHandler('handleFilesAdded', blockKey, this.handleFilesAdded.bind(this));
                store.setBlockHandler('handleMetadataChange', blockKey, this.handleMetadataChange.bind(this));
            }
        }
    }, _define_property(_ImageComponentWrapper, "sizeClassName", (componentData, theme, styles, isMobile)=>sizeClassName(componentData, theme, styles, isMobile)), _define_property(_ImageComponentWrapper, "alignmentClassName", (componentData, theme, styles, isMobile)=>alignmentClassName(componentData, theme, styles, isMobile)), _ImageComponentWrapper));
}
